import { EventTitles } from './app-wrapper-events.js'
import appWrapperUtils from './app-wrapper-utils.js'

const promisePublishHandle = appWrapperUtils.promisePublishHandle

const appWrapperWebImplementation = {
  openSurvey(resolve, reject, surveyInstanceID) {
    console.error(
      'OpenSurvey method is depricated from this API. Please use inbox-api instead.'
    )
    return promisePublishHandle(EventTitles.surveyOpen, {
      surveyInstanceID: surveyInstanceID
    })
  },
  openInBrowser(resolve, reject, config) {
    promisePublishHandle(EventTitles.contentLoad, config, 5000)
      .then(function(res) {
        resolve(res)
      })
      .catch(function(error) {
        reject(error)
      })
  }
}

export default appWrapperWebImplementation
